module.exports = __webpack_public_path__ + "static/media/ic_nav_reminder.a91e0b4c.svg";